const STORAGE_KEY = 'mySessionsLayout';

const DEFAULT_LAYOUT = {
    viewType: 'default',
    verticalSplit: ['42%', '58%'],
    horizontalSplit: ['50%', '50%'],
    panelOrder: ['sessionCard', 'content']
};

export const loadLayoutPreferences = () => {
    try {
        const item = localStorage.getItem(STORAGE_KEY);
        return item ? { ...DEFAULT_LAYOUT, ...JSON.parse(item) } : DEFAULT_LAYOUT;
    } catch (error) {
        console.error('Failed to load layout preferences:', error);
        return DEFAULT_LAYOUT;
    }
};

export const saveLayoutPreferences = (layoutPreferences) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(layoutPreferences));
    } catch (error) {
        console.error('Failed to save layout preferences:', error);
    }
};